module.exports = __webpack_public_path__ + "static/media/tracking.f9d42716.png";